import { AlexaCommon } from "./Common";
import AudioTest from './PlayHTTP2ResponseAudioTest';

export class AVSWrapperUtil {

 
  //return array of audio object
  static parseAlexaAudioResponse(xhr, response) {

    if (!response || !xhr) { return; }

    var audios = [];
    var audioMap = {};
    var directive = null;

    if (response.multipart.length) {
      response.multipart.forEach(multipart => {
        let body = multipart.body;
        if (multipart.headers != null && multipart.headers['Content-Type'] === 'application/json; charset=UTF-8') {
          try {
            body = JSON.parse(body);
          } catch (error) {
            console.error(error);
          }

          if (body && body.directive && body.directive.header.namespace === "SpeechSynthesizer") {
            directive = body.directive;
          }
        } else if (multipart.headers != null && multipart.headers['Content-Type'] === 'application/octet-stream') {
          const start = multipart.meta.body.byteOffset.start;
          const end = multipart.meta.body.byteOffset.end;
          let audioContentId = AlexaCommon.getOctetContentID(multipart.headers['Content-ID']);
          /**
           * Not sure if bug in buffer module or in http message parser
           * because it's joining arraybuffers so I have to this to
           * seperate them out.
           */
          var slicedBody = multipart.body.slice(start, end);

          audioMap[audioContentId] = slicedBody;
        }
      });

      function findAudioFromContentId(contentId) {
        contentId = contentId.replace('cid:', '');
        for (var key in audioMap) {
          if (key.indexOf(contentId) > -1) {
            return audioMap[key];
          }
        }
      }
      if (directive != null) {
          if (directive.header.namespace === "SpeechSynthesizer") {
            if (AlexaCommon.getLowerCase(directive.header.name) === "speak") {
              const contentId =
                directive.payload.url;
              localStorage.setItem('speakToken', directive.payload.token)  
              const audio = findAudioFromContentId(contentId);
              if (audio) {
                audios.push(audio);
              }
            }
          }
      }
      return audios;
    }
  }

  //return array of cards.
  static parseAlexaCardsInfo(xhr, response) {
    if (!response || !xhr) { return; }

    var cardPayload = {};
    var directive = null;

    if (response.multipart.length) {
      response.multipart.forEach(multipart => {
        let body = multipart.body;
        if (multipart.headers != null && multipart.headers['Content-Type'] === 'application/json; charset=UTF-8') {
          try {
            body = JSON.parse(body);
          } catch (error) {
            console.error(error);
          }

          if (body && body.directive && body.directive.header.namespace === "TemplateRuntime") {
            directive = body.directive;
          }
        }
      });
      if (directive != null) {
        if (directive.header.namespace === "TemplateRuntime") {
          if (directive.header.name === "RenderTemplate") {
            cardPayload = directive.payload;
          }
        };
      }
      return cardPayload;
    }
  }
  static parseAlexaListenDirective(xhr, response) {
    if (!response || !xhr) { return; }

    var listenDirective = {};
    var directive = null;

    if (response.multipart.length) {
      response.multipart.forEach(multipart => {
        let body = multipart.body;
        if (multipart.headers != null && multipart.headers['Content-Type'] === 'application/json; charset=UTF-8') {
          try {
            body = JSON.parse(body);
          } catch (error) {
            console.error(error);
          }

          if (body && body.directive && body.directive.header.namespace === "SpeechRecognizer") {
            directive = body.directive;
          }
        }
      });
      if (directive != null) {
          if (directive.header.namespace === "SpeechRecognizer") {
            if (directive.header.name === "ExpectSpeech") {
              console.log(JSON.stringify(directive))
              localStorage.setItem('dialogRequestId', directive.header.dialogRequestId);
              listenDirective = directive.payload;
            }
          }        
      }
      return listenDirective;
    }
  }
}